<section>
  <app-ice-back-button
    testId="change-additional-services-back-link"
    (click)="finishedChanging.emit()"
    (keydown.enter)="finishedChanging.emit()"
  />

  @if (product().isLoadingSubscriptionDetails || isLoadingAdditionalServiceOfferings()) {
    <app-spinner />
  } @else {
    <form class="form" [formGroup]="$any(form)" (ngSubmit)="onSave()">
      @if (isRegularIceJunior) {
        <div class="ice-junior-whitelist-disclaimer">
          <app-ice-alert iconWidth="2rem" type="info" [iconName]="IconNames.ice_junior">
            <div heading>Gratisnummer iceJunior</div>
            <div>For eksisterende kunder må gratisnummer legges til og endres på Min Side eller i Ice-appen.</div>
          </app-ice-alert>
        </div>
      }
      <div class="additional-services-list">
        @if (hasAvailableAdditionalServices) {
          <div class="heading">Tilleggstjenester</div>
        }

        @for (group of simGroups(); track group.key) {
          <app-additional-sim-group
            [activeSims]="group.activeSims"
            [rows]="simRows()[group.key]"
            [service]="group.service"
            (add)="addSimRow(group)"
            (clear)="clearSimRows(group)"
            (remove)="removeSimRow(group, $event)"
          />
        }

        @for (item of form.controls; track $index) {
          <div [formGroup]="$any(item)">
            @if (!item.get('isMutexService')) {
              @if (getAdditionalService($any(item)); as additionalService) {
                <app-additional-service
                  iccControlName="icc"
                  selectionControlName="selected"
                  simDeliveryControlName="simDelivery"
                  [additionalService]="additionalService"
                  [product]="product()"
                />
              }
            } @else {
              @if (getMutexService($any(item)); as mutexService) {
                <app-mutex-additional-service
                  mutexControlName="selectedMutexService"
                  selectionControlName="selected"
                  [mutexSet]="mutexService"
                />
              }
            }
          </div>
        }

        @if (!!assignedVasProduct) {
          <div class="offering-vas">
            <h3>{{ getUniqueSellingPointsTitle(assignedVasProduct.productName) }}</h3>
            <app-ice-pill [type]="'primary'">
              <div class="offering-vas-content">
                {{ assignedVasProduct.productName }}
                <span>{{ assignedVasProduct.monthlyPrice?.price | priceFormat: PriceType.Monthly : 'Inkludert' }}</span>
              </div>
            </app-ice-pill>
            @if (getExistingValueAddedServiceExplanation(assignedVasProduct.productName); as explanation) {
              <app-ice-info-box class="offering-vas-explanation">
                @for (paragraph of explanation; track paragraph) {
                  <p>
                    {{ paragraph }}
                  </p>
                }
              </app-ice-info-box>
            }
          </div>
        }
      </div>

      <app-ice-button
        class="submit-button"
        color="primary"
        testId="submit-change-additional-services-button"
        type="submit"
        [disabled]="!(formHasChanges && form.valid && simForm.valid)"
      >
        Bekreft
      </app-ice-button>
    </form>
  }
</section>
